var callbacks = [];
var fullContext = {};
export function addEventListener(cb) {
    callbacks.push(cb);
    return function () {
        callbacks = callbacks.filter(function (callback) { return cb !== callback; });
    };
}
export function DANGEROUSLY_REMOVE_ALL_LISTENERS() {
    callbacks = [];
}
export function triggerEvent(payload, meta, _fullContext) {
    callbacks.forEach(function (cb) { return cb(payload, meta, _fullContext); });
}
export function validateAndSetContext(contextName, contextValue, contextSchema) {
    try {
        var validatedPayload = contextSchema(contextValue);
        fullContext[contextName] = validatedPayload;
    }
    catch (error) {
        console.warn("[%schemasetName-events]: context \"" + contextName + "\" - " + error.message);
    }
}
export function DANGEROUSLY_RESET_ALL_CONTEXTS() {
    fullContext = {};
}
export function validateAndTriggerEvent(eventMeta, eventSchema, eventPayload, contextNames) {
    var pickedContexts = {};
    for (var _i = 0, contextNames_1 = contextNames; _i < contextNames_1.length; _i++) {
        var contextName = contextNames_1[_i];
        var contextValue = fullContext[contextName];
        if (typeof contextValue === "undefined") {
            console.warn("[fe-events]: context \"" + contextName + "\" is not set when triggering event \"" + eventMeta.name + "\"");
            return;
        }
        pickedContexts[contextName] = contextValue;
    }
    try {
        var validatedPayload = eventSchema(eventPayload);
        triggerEvent(validatedPayload, eventMeta, pickedContexts);
    }
    catch (error) {
        console.warn("[fe-events]: event \"" + eventMeta.name + "\" - " + error.message);
    }
}
//# sourceMappingURL=listener.js.map